import ScreenHeader from "@/components/ScreenHeader";
import { useTranslation } from "react-i18next";
import "./style.css";
const SideCol = ({ title, icon, children, className =""}) => {
  const { t } = useTranslation();
  return (
    <div className="relative-Side">
      <div className={`col-sidebar ${className}`}>
      <div className="col-card">
        <ScreenHeader
          title={title}
          icon={icon}
          className="bg-transparent mx-0 px-0 text-primary"
        />

        {children}
      </div>
    </div>
    </div>
  );
};

export default SideCol;


